export {default} from "./DealDetail";
